"use client";

import React, { JSX, useRef } from "react";
import { useParallax } from "@/hooks/useParallax";
import styles from "./TextSection.module.scss";

interface TextSectionProps {
	heading?: string | JSX.Element;
	content: string | string[] | JSX.Element;
	layout?: "single" | "two-column" | "small";
	className?: string;
}

const TextSection: React.FC<TextSectionProps> = ({
	heading,
	content,
	layout = "single",
	className
}) => {
	const contentRef = useRef<HTMLDivElement>(null);

	// Apply subtle parallax to text content
	useParallax(contentRef, {
		speed: 1.05,
		direction: "up",
		distance: 30,
		scrub: 1.5,
	});

	const renderContent = () => {
		if (Array.isArray(content)) {
			return content.map((paragraph, index) => (
				<div key={index} className={styles["text-section__paragraph"]}>{paragraph}</div>
			));
		}
		return (
			<div className={styles["text-section__paragraph"]}>{content}</div>
		);
	};

	return (
		<section className={`${styles["text-section"]} ${styles[`text-section--${layout}`]} ${className || ""}`}>
			{heading && (
				<h2 className={styles["text-section__heading"]}>{heading}</h2>
			)}
			<div ref={contentRef} className={styles["text-section__content"]}>
				{renderContent()}
			</div>
		</section>
	);
};

export default TextSection;
